import { render, staticRenderFns } from "./table.vue?vue&type=template&id=0bd5b08a"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd5b08a')) {
      api.createRecord('0bd5b08a', component.options)
    } else {
      api.reload('0bd5b08a', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=0bd5b08a", function () {
      api.rerender('0bd5b08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/business_leave/form/components/table.vue"
export default component.exports